import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DefaultTheme } from '@mui/styles';

export const useComponentHeightMeasuring = (appPaperPresence = false) => {
	const [availableHeight, setAvailableHeight] = React.useState('75vh');
	const [headerHeight, setHeaderHeight] = React.useState(59);
	const [footerHeight, setFooterHeight] = React.useState(64);

	const md = useMediaQuery((theme: DefaultTheme) => theme.breakpoints.up('md'));

	const figureAvailableHeight = () => {
		const windowHeight = window.innerHeight;
		const headerHeight = document.getElementById('app-header')?.offsetHeight ?? 0;

		setHeaderHeight(headerHeight);

		const appFooterHeight = document.getElementById('app-footer')?.offsetHeight ?? 0;

		setFooterHeight(appFooterHeight);

		const breadcrumbs = document.getElementById('app-breadcrumbs');
		const breadcrumbsHeight = breadcrumbs?.offsetHeight ? breadcrumbs.offsetHeight + 40 : 0;

		const pricingPlanWarning = document.getElementById('pricing-plan-warning');
		const pricingPlanWarningHeight = pricingPlanWarning?.offsetHeight
			? pricingPlanWarning.offsetHeight + 24
			: 0;

		const layoutPaddings = md ? 80 : 64;

		let additionalPaddings = 16;
		if (appPaperPresence) {
			additionalPaddings += md ? 64 : 32;
		}

		const height =
			windowHeight -
			headerHeight -
			appFooterHeight -
			breadcrumbsHeight -
			pricingPlanWarningHeight -
			additionalPaddings -
			layoutPaddings;

		setAvailableHeight(`${height}px`);
	};

	React.useLayoutEffect(() => {
		figureAvailableHeight();

		window.addEventListener('resize', figureAvailableHeight, { passive: true });

		return () => {
			window.removeEventListener('resize', figureAvailableHeight);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { availableHeight, footerHeight, headerHeight };
};
